/* CRAFTD - scrolling announcement ticker.
 *
 * The theme ships the announcement bar as a slider: one message at a time,
 * with prev/next arrows. This keeps the section, its messages and the
 * height-observer element the sticky header measures, and swaps only the
 * slider's contents for a single continuous track.
 *
 * The track holds two identical passes of the message list, and the CSS
 * animates it to -50%, so the loop repeats on the seam with no jump.
 *
 * An asset, not inline: inline <script> blocks on this store get rewritten to
 * type=text/lazyload for some visitors.
 */
(function () {
  'use strict';
  if (window.croTickerBooted) return;
  window.croTickerBooted = true;

  function boot() {
    var bar = document.querySelector('.shopify-section--announcement-bar');
    if (!bar || bar.querySelector('.cro-ticker')) return;

    /* the slider repeats its slides for looping, so dedupe as we collect */
    var msgs = [];
    bar.querySelectorAll('p').forEach(function (p) {
      if (p.closest('.sr-only')) return;
      var t = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t || t.length > 80) return;
      if (msgs.indexOf(t) === -1) msgs.push(t);
    });
    if (!msgs.length) return;

    var track = document.createElement('div');
    track.className = 'cro-ticker__track';
    for (var pass = 0; pass < 2; pass++) {
      msgs.forEach(function (m) {
        var s = document.createElement('span');
        s.className = 'cro-ticker__item';
        s.textContent = m;
        track.appendChild(s);
        var d = document.createElement('i');
        d.className = 'cro-ticker__dot';
        d.setAttribute('aria-hidden', 'true');
        track.appendChild(d);
      });
    }

    var wrap = document.createElement('div');
    wrap.className = 'cro-ticker';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', 'Announcements');
    wrap.appendChild(track);

    /* replace the slider inside the height-observer rather than the section,
       so the element the sticky header measures still has real content */
    var host = bar.querySelector('height-observer') || bar;
    host.innerHTML = '';
    host.appendChild(wrap);

    /* pace by length, so a long message list does not crawl */
    var seconds = Math.round(track.scrollWidth / 95);
    if (seconds < 18) seconds = 18;
    if (seconds > 70) seconds = 70;
    track.style.animationDuration = seconds + 's';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
